import { z } from 'zod';

export const sexSchema = z.enum(['man', 'woman']);

export type SexSchema = z.infer<typeof sexSchema>;
